<template>
  <div class="resume">
    <div class="banner"></div>

    <div class="profile">
      <div class="profile-header">
        <div class="title">
          <div class="cont_tit">
            <div>
              <p>我的简历</p>
              <span>My Resume</span>
            </div>
            <div style="margin-top: 10px" v-if="userInfo.realName">
              <label>
                <i class="el-icon-time"></i>
                最近更新:
              </label>
              <time>{{ userInfo.updateTime | formatDate }}</time>
            </div>
          </div>
          <div class="crumb">
            <span>当前位置：</span>
            <a href="../" target="_self" title="首页" class="CurrChnlCls"
              >首页</a
            >&gt;<a href="" target="_self" title="我的简历" class="CurrChnlCls"
              >我的简历</a
            >
          </div>
        </div>
      </div>

      <div class="resumeForm">
        <div class="text">
          温馨提示：
          <p>
            1.请务必填写<span style="color: blue">个人信息</span>、<span
              style="color: blue"
              >求职意向</span
            >与<span style="color: blue">个人优势</span
            >。
          </p>
          <p>2.完善工作经验、教育背景等信息，有利于提升求职竞争力。</p>
        </div>
        <!-- 基本信息 -->
        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">基本信息</h2>
          <div class="profile-header__editor-button">
            <router-link to="/resume/basic">
              <el-button plain round icon="el-icon-edit">编辑</el-button>
            </router-link>
          </div>
          <div class="resumeViewForm" v-if="userInfo.realName">
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">姓名</div>
              <div class="resumeViewItem__content">
                {{ userInfo.realName }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">性别</div>
              <div class="resumeViewItem__content">
                {{ userInfo.gender }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">手机号</div>
              <div class="resumeViewItem__content">
                {{ state.phoneNumber }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">邮箱</div>
              <div class="resumeViewItem__content">
                {{ userInfo.emailAddress }}
              </div>
            </div>
          </div>
        </div>
        <!-- 求职意向 -->
        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">求职意向</h2>
          <div class="profile-header__editor-button">
            <router-link to="/resume/intention">
              <el-button plain round icon="el-icon-edit">编辑</el-button>
            </router-link>
          </div>
          <div class="resumeViewForm" v-if="userInfo.workingPlace">
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">工作地点</div>
              <div class="resumeViewItem__content">
                {{ userInfo.workingPlace }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">期望薪资</div>
              <div class="resumeViewItem__content">
                {{ userInfo.hopeSalary }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">职位类别</div>
              <div class="resumeViewItem__content">
                {{ userInfo.jobPosition }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">求职状态</div>
              <div class="resumeViewItem__content">
                {{ userInfo.jobSeeking }}
              </div>
            </div>
          </div>
        </div>

        <!-- 个人优势 -->
        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">个人优势</h2>
          <div class="profile-header__editor-button">
            <router-link to="/resume/advantage">
              <el-button plain round icon="el-icon-edit">编辑</el-button>
            </router-link>
          </div>
          <div class="resumeViewForm" v-if="personalAdventage">
            <div class="resumeViewItem resumeViewItem-desc">
              {{ personalAdventage }}
            </div>
          </div>
        </div>
        <!-- 工作经历 -->
        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">工作经历</h2>

          <div
            v-if="workExperienceList && workExperienceList.length"
            :key="index"
            v-for="(item, index) in workExperienceList"
            class="resumeViewForm clearfix"
          >
            <div class="resumeViewItem">
              <div class="profile-header__editor-button">
                <router-link
                  :to="{
                    name: 'resume-experience-params',
                    params: { id: item.miniProgramWorkExperienceId },
                  }"
                >
                  <el-button plain round icon="el-icon-edit">编辑</el-button>
                </router-link>
              </div>
              <div class="resumeViewItem__label">公司</div>
              <div class="resumeViewItem__content">{{ item.companyName }}</div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">起止时间</div>
              <div class="resumeViewItem__content">
                {{ item.startTime | formatDate(false) }} ~
                {{ item.endTime | formatDate(false) }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">职位</div>
              <div class="resumeViewItem__content">{{ item.jobPosition }}</div>
            </div>
            <div
              class="resumeViewItem resumeViewItem-desc"
              v-if="item.workDescription"
            >
              <div class="resumeViewItem__label">描述</div>
              <div class="resumeViewItem__content">
                {{ item.workDescription }}
              </div>
            </div>
            <div
              class="profile-header__remove-button"
              @click="WorkExperienceRemove(item.miniProgramWorkExperienceId)"
            >
              <el-button plain round icon="el-icon-delete">删除</el-button>
            </div>
          </div>

          <div class="addition">
            <router-link :to="{ name: 'resume-experience' }">
              <i class="el-icon-plus"></i><span>添加</span>
            </router-link>
          </div>
        </div>
        <!-- 教育经历 -->
        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">教育经历</h2>

          <div
            v-if="educationExperienceList && educationExperienceList.length"
            :key="index"
            v-for="(item, index) in educationExperienceList"
            class="resumeViewForm clearfix"
          >
            <div class="resumeViewItem">
              <div class="profile-header__editor-button">
                <router-link
                  :to="{
                    name: 'resume-education-params',
                    params: { id: item.miniProgramEducationId },
                  }"
                >
                  <el-button plain round icon="el-icon-edit">编辑</el-button>
                </router-link>
              </div>
              <div class="resumeViewItem__label">学校</div>
              <div class="resumeViewItem__content">{{ item.schoolName }}</div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">起止时间</div>
              <div class="resumeViewItem__content">
                {{ item.startTime | formatDate(false) }} ~
                {{ item.endTime | formatDate(false) }}
              </div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">专业</div>
              <div class="resumeViewItem__content">{{ item.majorIn }}</div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">学历</div>
              <div class="resumeViewItem__content">
                {{ item.educationLevel }}
              </div>
            </div>
            <div
              class="profile-header__remove-button"
              @click="EducationRemove(item.miniProgramEducationId)"
            >
              <el-button plain round icon="el-icon-delete">删除</el-button>
            </div>
          </div>

          <div class="addition">
            <router-link :to="{ name: 'resume-education' }">
              <i class="el-icon-plus"></i><span>添加</span>
            </router-link>
          </div>
        </div>

        <!-- 项目 -->
        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">项目</h2>

          <div
            v-if="projectExperienceList && projectExperienceList.length"
            :key="index"
            v-for="(item, index) in projectExperienceList"
            class="resumeViewForm clearfix"
          >
            <div class="resumeViewItem">
              <div class="profile-header__editor-button">
                <router-link
                  :to="{
                    name: 'resume-project-params',
                    params: { id: item.miniProgramProjectExperienceId },
                  }"
                >
                  <el-button plain round icon="el-icon-edit">编辑</el-button>
                </router-link>
              </div>
              <div class="resumeViewItem__label">项目名称</div>
              <div class="resumeViewItem__content">{{ item.projectName }}</div>
            </div>
            <div class="resumeViewItem">
              <div class="resumeViewItem__label">起止时间</div>
              <div class="resumeViewItem__content">
                {{ item.startTime | formatDate(false) }} ~
                {{ item.endTime | formatDate(false) }}
              </div>
            </div>
            <div
              class="resumeViewItem resumeViewItem-desc"
              v-if="item.projectDescription"
            >
              <div class="resumeViewItem__label">描述</div>
              <div class="resumeViewItem__content">
                {{ item.projectDescription }}
              </div>
            </div>
            <div
              class="profile-header__remove-button"
              @click="ProjectRemove(item.miniProgramProjectExperienceId)"
            >
              <el-button plain round icon="el-icon-delete">删除</el-button>
            </div>
          </div>
          <div class="addition">
            <router-link :to="{ name: 'resume-project' }">
              <i class="el-icon-plus"></i><span>添加</span>
            </router-link>
          </div>
        </div>

        <div class="preview" v-if="userInfo.realName && userInfo.workingPlace">
          <div class="preview-but" @click="getPreview">
            <i class="el-icon-reading"></i><span>预览简历</span>
          </div>
        </div>

        <div class="resumeViewSection">
          <h2 class="resumeViewSection__title">简历</h2>
          <div
            class="resumeViewItem resumeViewItem__resumeAttachment"
            v-if="resume"
          >
            <div class="profile-header__editor-button">
              <router-link to="/resume/edit">
                <el-button plain round icon="el-icon-edit">上传简历</el-button>
              </router-link>
            </div>
            <div class="fileIcon">
              <file-icon :file-type="resumeFileType"></file-icon>
            </div>
            <div class="content">
              <h5>{{ resume }}</h5>
            </div>
            <div class="download-link">
              <a @click="getUpload(resume)">
                <i class="el-icon-download"></i>
              </a>
            </div>
          </div>
          <div class="addition" v-if="!resume">
            <router-link to="/resume/edit">
              <i class="el-icon-plus"></i><span>上传简历</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="open"
      width="900px"
      append-to-bod
      :close-on-click-modal="false"
    >
      <div class="resume-container" id="resumeTemplate">
        <div>
          <!-- 头部模块 -->
          <header class="resume-header">
            <div class="avatar-section">
              <img :src="avatar" alt="头像" class="avatar" />
              <div class="personal-basic">
                <h1>Hello, I'm {{ userInfo.realName }}</h1>
                <p class="basic-info">
                  {{ userInfo.gender }} | {{ currentYear - getinfo }}岁 |
                  电话：{{ state.phoneNumber }}
                </p>
                <p class="contact-info">
                  学历：{{ userInfo.educationLevel }} | 邮箱：{{
                    userInfo.emailAddress
                  }}
                </p>
              </div>
            </div>
          </header>

          <!-- 双栏内容区 -->
          <main class="resume-content">
            <!-- 左栏 -->
            <div class="left-column">
              <section class="info-box">
                <h2 class="section-title"><span>◆</span> 求职信息</h2>
                <div class="info-item">
                  <label>工作经验：</label>
                  <span>{{ userInfo.workingTime }}</span>
                </div>
                <div class="info-item">
                  <label>求职意向：</label>
                  <span>{{ userInfo.jobPosition }}</span>
                </div>
                <div class="info-item">
                  <label>期望薪资：</label>
                  <span>{{ userInfo.hopeSalary }}</span>
                </div>
                <div class="info-item">
                  <label>期望城市：</label>
                  <span>{{ userInfo.workingPlace }}</span>
                </div>
                <div class="info-item">
                  <label>求职状态：</label>
                  <span>{{ userInfo.jobSeeking }}</span>
                </div>
              </section>

              <section class="info-box" v-if="personalAdventage">
                <h2 class="section-title"><span>◆</span> 个人优势</h2>
                <div class="advantage-list">
                  <p>
                    {{ personalAdventage }}
                  </p>
                </div>
              </section>
            </div>

            <!-- 右栏 -->
            <div class="right-column">
              <section
                class="info-box"
                v-if="educationExperienceList && educationExperienceList.length"
              >
                <h2 class="section-title"><span>◆</span> 教育经历</h2>
                <div
                  class="education-item"
                  v-for="(item, index) in educationExperienceList"
                  :key="index"
                >
                  <div class="education-header">
                    <h3>{{ item.schoolName }}</h3>
                    <span class="duration">{{ item.educationLevel }}</span>
                    <span></span>
                  </div>
                  <p class="majorIn">{{ item.majorIn }}</p>
                  <p class="education-time">
                    {{ item.startTime | formatDate(false) }} ~
                    {{ item.endTime | formatDate(false) }}
                  </p>
                </div>
              </section>

              <section
                class="info-box"
                v-if="workExperienceList && workExperienceList.length"
              >
                <h2 class="section-title"><span>◆</span> 工作经历</h2>
                <div
                  v-for="(item, index) in workExperienceList"
                  :key="index"
                  class="experience-item"
                >
                  <div class="company-header">
                    <h3>{{ item.companyName }}</h3>
                    <span class="duration"
                      >{{ item.startTime | formatDate(false) }} ~
                      {{ item.endTime | formatDate(false) }}</span
                    >
                  </div>
                  <p class="position">{{ item.jobPosition }}</p>
                  <div class="responsibility-list">
                    <p>
                      {{ item.workDescription }}
                    </p>
                  </div>
                </div>
              </section>

              <section
                class="info-box"
                v-if="projectExperienceList && projectExperienceList.length"
              >
                <h2 class="section-title"><span>◆</span> 项目经历</h2>
                <div
                  class="project-item"
                  v-for="(item, index) in projectExperienceList"
                  :key="index"
                >
                  <div class="project-header">
                    <h3>{{ item.projectName }}</h3>
                    <span class="duration"
                      >{{ item.startTime | formatDate(false) }} ~
                      {{ item.endTime | formatDate(false) }}</span
                    >
                  </div>
                  <div class="responsibility-list">
                    <p>
                      {{ item.projectDescription }}
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </main>
        </div>
      </div>
      <div class="preview">
        <div class="preview-but" @click="hotPreview">
          <i class="el-icon-download"></i><span>生成简历</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  personalInfo,
  deleteWorkExperience,
  deleteEducationExperience,
  deleteProjectExperience,
  download,
  resumeUpload,
} from "@/api/index";
import store from "@/store";
import { generateResumePDF } from "@/helper/pdfGenerator";
import COS from "cos-js-sdk-v5";
export default {
  name: "resume",
  data() {
    return {
      URL: "/prod-api",
      state: store.state,
      resume: "",
      userInfo: "",
      jobSeeking: "",
      personalAdventage: "",
      workExperienceList: [],
      educationExperienceList: [],
      projectExperienceList: [],
      resumeAttachmentLink: "",
      open: false,
      title: "",
      currentYear: "",
      avatar: require("@/assets/images/tx.jpeg"),
    };
  },
  computed: {
    resumeFileType() {
      const pathArr = this.resume.split(".");
      return pathArr[pathArr.length - 1].toLowerCase();
    },
    getinfo() {
      if (this.userInfo.birthday) {
        return this.userInfo.birthday.split("-")[0];
      }
    },
  },
  created() {
    this.currentYear = new Date().getFullYear();
    this.getPersonalInfo();
  },
  methods: {
    //简历下载
    getUpload(resume) {
      this.showLoading();
      download(resume).then((response) => {
        this.load.close();
        this.getObjectURL(response, resume);
      });
    },
    // 将返回的文件流数据转换为url（data: 文件流数据）
    getObjectURL(data, contractFileName) {
      let blob = new Blob([data]);
      let fileName = contractFileName;
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        //释放内存
        window.URL.revokeObjectURL(link.href);
      }
    },

    getPersonalInfo() {
      const loading = this.$loading();
      personalInfo()
        .then((res) => {
          loading.close();
          if (res.code == 200) {
            this.resume = res.data.resume;
            if (res.data.reMiniProgramPerson) {
              this.userInfo = res.data.reMiniProgramPerson;
              this.jobSeeking = res.data.reMiniProgramPerson.jobSeeking;
              this.personalAdventage =
                res.data.reMiniProgramPerson.personalAdventage;
              store.setUserName(res.data.reMiniProgramPerson.realName);
            }
            this.workExperienceList = res.data.workExperienceList;
            this.educationExperienceList = res.data.educationExperienceList;
            this.projectExperienceList = res.data.projectExperienceList;
          }
        })
        .catch((err) => {
          loading.close();
        });
    },

    //工作经历删除
    WorkExperienceRemove(id) {
      deleteWorkExperience(id)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.getPersonalInfo();
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {});
    },

    //学历删除
    EducationRemove(id) {
      deleteEducationExperience(id)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.getPersonalInfo();
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {});
    },

    //项目删除
    ProjectRemove(id) {
      deleteProjectExperience(id)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.getPersonalInfo();
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {});
    },

    getPreview() {
      this.open = true;
      this.title = "简历预览";
    },

    //生成简历
    async hotPreview() {
      // 通过 .then() 获取
      generateResumePDF("resumeTemplate", this.userInfo.realName)
        .then((file) => {
          // 执行上传
          if (this.resume) {
            this.$messageBox(
              "您已经上传附件，是否用生成的附件替换上传的附件?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
              }
            )
              .then(() => {
                this.uploadPDF(file);
                this.$notify.success("简历已保存并上传");
              })
              .catch(() => {});
          } else {
            this.uploadPDF(file);
            this.$notify.success("简历已保存并上传");
          }
        })
        .catch((err) => {
          console.error("生成失败:", err);
        });
    },

    uploadPDF(file) {
      let objectKey =
        "微信招聘小程序/用户信息/附件简历/" +
        this.userInfo.realName +
        "/" +
        this.state.phoneNumber +
        ".pdf";

      let filesSize = file.size;
      if (filesSize / (1024 * 1024) < 30) {
        this.uploads(file, objectKey);
      } else {
        this.$message({
          type: "warning",
          message: "文件过大，建议不要超过30M！",
        });
      }
    },

    //loading
    showLoading() {
      this.load = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    //上传
    uploads(file, objectKey) {
      let _this = this;
      _this.showLoading();
      // 初始化实例
      const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          const url = _this.URL + "/api/miniProgram/getCosAuth";
          const xhr = new XMLHttpRequest();
          xhr.open("get", url, true);
          xhr.onload = function (e) {
            let data = JSON.parse(xhr.response).data;
            let timestamp = Math.floor(data.startTime / 1000);
            callback({
              TmpSecretId: data.tmpSecretId,
              TmpSecretKey: data.tmpSecretKey,
              SecurityToken: data.sessionToken,
              StartTime: timestamp, // 时间戳，单位秒，如：1580000000
              ExpiredTime: timestamp + 60, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
      });

      cos.uploadFile(
        {
          Bucket: "zhaopin-1322091753" /* 填写自己的 bucket，必须字段 */,
          Region: "ap-nanjing" /* 存储桶所在地域，必须字段 */,
          Key: objectKey /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
          Body: file, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            30 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function (err, data) {
          if (err) {
            _this.load.close();
            _this.$message.error("上传失败");
          } else {
            resumeUpload(objectKey)
              .then((res) => {
                if (res.code == 200) {
                  _this.resume = objectKey;
                  _this.load.close();
                  _this.$message({
                    type: "success",
                    message: "上传成功!",
                  });
                  this.getPersonalInfo();
                } else {
                  _this.load.close();
                  this.$message({
                    type: "warning",
                    message: res.msg,
                  });
                }
              })
              .catch(() => {});
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/czqypc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}

.profile {
  width: 900px;
  margin: auto;
  &-header {
    padding-top: 50px;
    margin-bottom: 50px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }
    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }
}

.resumeForm {
  margin: 30px 0;
  background: #fff;
  box-shadow: 0px 9px 20px 0px #c2c1c180;
  border-radius: 4px;
  padding: 30px;
  .text {
    margin-bottom: 20px;
    color: red;
  }
  .profile-header__editor-button {
    position: absolute;
    right: 0;
    z-index: 10;
  }
  .resumeViewSection {
    min-height: 100px;
    overflow: hidden;
    margin-bottom: 30px;
    position: relative;
    &__title {
      margin-bottom: 20px;
    }
    &__title::after {
      position: absolute;
      top: 34px;
      left: 0;
      content: "";
      width: 30px;
      height: 4px;
      background-color: #00a0e9;
    }
    .resumeViewForm:nth-last-child(1) {
      border-bottom: none;
    }
    .resumeViewForm {
      margin-bottom: 20px;
      border-bottom: 1px dashed #c2c1c180;
      position: relative;
      min-height: 120px;
      .profile-header__remove-button {
        position: absolute;
        right: 0;
        bottom: 20px;
      }
    }
    .resumeViewItem {
      float: left;
      width: 50%;
      margin-bottom: 20px;
      min-height: 50px;
      &__resumeAttachment {
        display: flex;
        padding: 10px;
        background-color: @bg-base-color;
        align-items: center;
        time {
          color: @regular-text-color;
          font-size: @font-size-base;
        }
        .fileIcon {
          margin-right: 10px;
          width: 50px;
          height: 50px;
        }
        .download-link {
          margin-left: auto;

          .el-icon-download {
            font-size: @font-size-large;
            border-radius: 50%;
            border: 1px solid @border-base-color;
            padding: 4px;
          }
          &:hover {
            color: @main-color;
          }
        }
      }
      &__content.is-link {
        color: @main-color;
        cursor: pointer;
      }
      &__label {
        color: @secondary-text-color;
        font-size: @font-size-base;
        margin-bottom: 7px;
      }
      &__content-link {
        color: @main-color;
      }
      &-desc {
        overflow: hidden;
        width: 88%;
        white-space: pre-line;
      }
    }
    .bottom-action {
      position: absolute;
      right: 0;
    }
    .addition {
      // border-top: 1px dashed #c2c1c180;
      color: #00a0e9;
      text-align: center;
      font-size: 16px;
      i {
        padding: 0 5px;
      }
    }
  }
}

.preview {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  .preview-but {
    border: 1px solid #00a0e9;
    background: #00a0e9;
    width: 200px;
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
    color: #fff;
    text-align: center;
  }
  i {
    padding: 0 5px;
  }
}

.resume-container {
  width: 794px;
  margin: 0 auto;
  background: #f9f6fc;
  font-family: "Microsoft YaHei", sans-serif;
  color: #333;
  position: relative;
}

.resume-header {
  padding: 30px;
  background: #6a5acd;
  position: relative;
  display: flex;
  justify-content: space-between;

  .avatar-section {
    display: flex;
    align-items: center;

    .avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      margin-right: 20px;
      border: 3px solid #fff;
    }

    .personal-basic {
      color: white;

      h1 {
        font-size: 28px;
        margin: 0 0 8px;
      }

      p {
        margin: 4px 0;
        font-size: 14px;
      }
    }
  }

  .decorative-text {
    writing-mode: vertical-rl;
    color: rgba(255, 255, 255, 0.3);
    font-size: 24px;
    letter-spacing: 4px;
  }
}

.resume-content {
  padding: 20px;
}

.info-box {
  margin-bottom: 25px;
  background: white;
  padding: 15px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  .section-title {
    color: #4b0082;
    font-size: 18px;
    border-left: 3px solid #9370db;
    padding-left: 10px;
    margin: 0 0 15px;

    span {
      color: #6a5acd;
      margin-right: 8px;
    }
  }
}

.advantage-list p {
  margin: 8px 0;
  padding-left: 15px;
  position: relative;
  white-space: pre-wrap;
  &::before {
    content: "▹";
    color: #6a5acd;
    position: absolute;
    left: 0;
  }
}

.education-item,
.experience-item,
.project-item {
  margin-bottom: 20px;

  .education-header {
    display: flex;
    span {
      margin-left: 20px;
    }
  }
  .company-header,
  .project-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      color: #4b0082;
    }

    .duration {
      color: #666;
      font-size: 14px;
    }
  }

  .position,
  .majorIn {
    color: #6a5acd;
    margin: 8px 0;
  }
}

.responsibility-list p {
  margin: 6px 0;
  padding-left: 15px;
  position: relative;
  white-space: pre-wrap;
  &::before {
    content: "•";
    color: #9370db;
    position: absolute;
    left: 0;
  }
}

@media print {
  // .resume-container {
  //   width: 794px !important;
  //   overflow: visible !important;
  // }

  .resume-container {
    padding: 50px 0 80px; /* 头尾预留空间 */
    page-break-inside: avoid;
  }

  /* 防止模块断裂 */
  .info-box {
    page-break-inside: avoid !important;
    break-inside: avoid;
  }

  /* 强制内容可见 */
  .resume-container ::v-deep * {
    max-height: none !important;
    overflow: visible !important;
  }
}
</style>
